import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleDepreciationFactorsConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleDepreciationFactors";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_DEPRECIATION_FACTORS = "DeleteMultipleprojectCycleDepreciationFactors";
    static FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_DEPRECIATION_FACTORS = "UploadprojectCycleDepreciationFactors";
}
